module.exports = __webpack_public_path__ + "static/media/children-walking-blue.136ace11.png";